// import './sentry';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ConnectedRouter } from "connected-react-router";
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { Provider } from 'react-redux';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import './app/token.js';
import './components/DatePicker/datePickerProvider';
import './fonts/fonts-open-sans.css';
import './fonts/fonts-noto-sans.css';
import './polyfills';
import appHistory from "./app/appHistory";
import MobileApp from "./MobileApp";
import mobileAppStore from "./mobileAppCore/mobileAppStore";
import LangProvider from "./providers/LangProvider/LangProvider";
import axiosInstance, { setupAxiosInterceptors } from "./app/axiosInstance";


// TODO CFD-3807 После объединения store и sagas убрать и сетапить в axiosInstance
setupAxiosInterceptors(axiosInstance, mobileAppStore);

Modal.setAppElement('#root');

ReactDOM.render(
    <Provider store={mobileAppStore}>
        <ConnectedRouter history={appHistory}>
            <React.StrictMode>
                <LangProvider>
                    <MobileApp />
                </LangProvider>
            </React.StrictMode>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);
